import React from 'react';
import { FaGithub, FaLinkedinIn, FaDiscord, FaTelegramPlane } from 'react-icons/fa';
import { IoLogoTwitter } from 'react-icons/io';

const HeaderLinks = () => {
  return (
    <div className="header__links">
      <a href="https://github.com/na2ib" target="_blank" rel="noopener noreferrer">
        <FaGithub />
      </a>
      <a href="https://linkedin.com/in/na2ib" target="_blank" rel="noopener noreferrer">
        <FaLinkedinIn />
      </a>
      <a href="https://www.discord.com/users/294708393661169664" target="_blank" rel="noopener noreferrer">
        <FaDiscord />
      </a>
      <a href="https://t.me/na2ib" target="_blank" rel="noopener noreferrer"> 
        <FaTelegramPlane />
      </a>
      <a href="https://x.com/__nazib__" target="_blank" rel="noopener noreferrer">
        <IoLogoTwitter />
      </a>
    </div>
  );
};

export default HeaderLinks;
